import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import type { SimpleDialog } from '../../models/simple-dialog';

@Component({
  selector: 'app-basic-dialog',
  templateUrl: './basic-dialog.component.html',
  styleUrls: ['./basic-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,  imports: [MatDialogContent, MatDialogActions, MatButtonModule],
})
export class BasicDialogComponent {
  dialogRef = inject<MatDialogRef<BasicDialogComponent>>(MatDialogRef);
  data = inject<SimpleDialog>(MAT_DIALOG_DATA);
  router = inject(Router);

  appUIComponent: SimpleDialog;
  constructor() {
    const dialogRef = this.dialogRef;
    const data = this.data;

    this.appUIComponent = data;
    dialogRef.disableClose = true;
  }

  onNoClick(): void {
    this.closeModal();
  }

  navigate(url?: string): void {
    this.closeModal();

    if (url) {
      this.router.navigate([url]);
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
